// extracted by mini-css-extract-plugin
module.exports = {"noStyleLink":"styles_noStyleLink__2OWyj"};